module.exports = __webpack_public_path__ + "img/point.60cb57c0.png";